export default __webpack_public_path__ + "static/freetrial-enrollment-thumb-ea6aef9603bbd44b345dc0ad66b135c5.png";